import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import { ROUTE_DISCOVER_QUESTIONNAIRE, ROUTE_DISCOVER_RESULT } from 'RouteList';
import BasePage from 'components/BasePage/BasePage';
import Content from 'components/BasePage/Content';
import Button from 'components/Button/Button';
import { Flex } from 'grid-styled';
import P from '../../components/P/P';
@withRouter
@inject('routing')
@observer
export default class Intro extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const { routing } = this.props;
    const { push } = routing;
    return (
      <BasePage>
        <Content verticalcenter>
          <Flex mb={4} width={1 / 1}>
            <P textcenter><FormattedMessage {...messages.discoverQuestionnaireDescription} /></P>
          </Flex>
          <Flex mb={4} width={1 / 1}>
            <Button full primary onClick={() => push(ROUTE_DISCOVER_QUESTIONNAIRE)}>
              <FormattedMessage {...messages.discoverQuestionnaire} />
            </Button>
          </Flex>
          <Flex mb={4} width={1 / 1}>
            <P textcenter><FormattedMessage {...messages.discoverResultDescription} /></P>
          </Flex>
          <Flex mb={4} width={1 / 1}>
            <Button full primary onClick={() => push(ROUTE_DISCOVER_RESULT)}>
              <FormattedMessage {...messages.discoverResult} />
            </Button>
          </Flex>
        </Content>
      </BasePage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/discover/Intro.js